import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Background } from './style';

const AuthLayout = (WrapperContent) => {
    const WrappedComponent = () => {
        const banner = [
            require('../../static/img/login/banner_4.png'),
        ];

        const [randomImage, setRandomImage] = useState('');

        useEffect(() => {
            const randomIndex = Math.floor(Math.random() * banner.length);
            setRandomImage(banner[randomIndex]);
            // eslint-disable-next-line react-hooks/exhaustive-deps
        }, []);

        return randomImage ? (
            <Background imageurl={randomImage}>
                <WrapperContent />
            </Background>
        ) : (
            <WrapperContent />
        );
    };

    return WrappedComponent;
};

AuthLayout.propTypes = {
    WrapperContent: PropTypes.elementType.isRequired,
};

export default AuthLayout;
